const ApiPath = {
  Authentication: "Authentication",
  Account: "Account",
  Organisation: "Organisation",
  Certificate: "Certificate",
  Project: "Project",
  Agency: "Agency",
  CaseWorker: "CaseWorker",
  Referrals: "Referrals",
  Employee: "Employee",
  JobSeeker: "JobSeeker",
  Common: "Common",
  Onet: "Onet",
  Notification: "Notification",
  EmployeeSurvey: "EmployeeSurvey",
  OrganisationVacantSurvey: "OrganisationVacantSurvey",
  OtherSurvey: "OtherSurvey",
  Apprentice: "Apprentice",
  Invoice: "Invoice",
  Subscription: "Subscription",
  ApprenticeSurvey: "ApprenticeSurvey",
  JobSeekerSurvey: "JobSeekerSurvey",
  UserInterest: "UserInterest",
  SubjectArea: "SubjectArea",
  Pathway: "Pathway",
  SkillsPassport: "SkillsPassport",
  Referrals: "Referrals",
  Onet: "Onet",
  RoleMatching: "RoleMatching",
  // WIOA Service
  Wioa: "WIOA",
};

export default ApiPath;
